<template>
  <Panel header="Registrar Evento">
    <Card>
      <template #content>
        <Steps :model="items" :readonly="true" style="margin-bottom: 1rem" />
      </template>
    </Card>
    <br />

    <keep-alive>
      <router-view
        :formObject="formObject"
        @prevPage="prevPage($event)"
        @nextPage="nextPage($event)"
        @complete="complete"
      />
    </keep-alive>
  </Panel>
  <dialog-rules-vue />

  <!-- Spinner and Overlay -->
  <div v-if="loading" class="overlay">
    <div class="spinner"></div>
  </div>
</template>

<script>
//MODELS
import Event from "../../models/internal/event";
import Responsible from "../../models/internal/responsible";

//Services
import EventService from "../../service/internal/event/event_service";

//Components
import DialogRulesVue from "./components/DialogRules.vue";

export default {
  components: {
    DialogRulesVue,
  },
  data() {
    return {
      service: new EventService(),
      loading: false, // Adicione esta linha
      items: [
        {
          label: "Responsável",
          to: "/agendamento",
        },
        {
          label: "Evento",
          to: "/agendamento/evento",
        },
        {
          label: "Calendário",
          to: "/agendamento/calendario",
        },
      ],
      formObject: new Event(),
      responsibleSelected: new Responsible({}),
    };
  },
  created() {
    this.$store.state.views.calendar.dialogRules = true;
  },
  methods: {
    nextPage(event) {
      switch (event.pageIndex) {
        case 0:
          this.responsibleSelected = event.formData.responsible;
          break;
        case 1:
          for (let field in event.formData) {
            this.formObject[field] = event.formData[field];
          }
          this.formObject.responsible = this.responsibleSelected;
          break;
      }

      this.$router.push(this.items[event.pageIndex + 1].to);
    },
    prevPage(event) {
      if (event.pageIndex === -1) {
        this.$router.push("/");
      } else {
        for (let field in event.formData) {
          this.formObject[field] = event.formData[field];
        }
        this.formObject.responsible = this.responsibleSelected;
        this.$router.push(this.items[event.pageIndex - 1].to);
      }
    },
    complete(event) {
      this.loading = true;

      this.formObject.calendars = event.calendars;
      let responsible = this.formObject.responsible;
      this.formObject.responsible = this.formObject.responsible.toJson();

      this.service
        .create(this.formObject)
        .then((res) => {
          this.$msgSuccess(res);
          setTimeout(() => {
            this.loading = false;
            this.$router.push("/");
          }, 700);
          this.formObject.responsible = responsible;
        })
        .catch((error) => {
          this.$msgErro(error);
          this.loading = false;
          return;
        })
        .finally(() => {
          this.formObject.responsible = responsible;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../../App.scss");
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* Certifique-se de que esteja acima de outros elementos */
}

.spinner {
  border: 8px solid #f3f3f3; /* Cor de fundo */
  border-top: 8px solid #3498db; /* Cor da borda giratória */
  border-radius: 50%;
  width: 50px; /* Tamanho da spinner */
  height: 50px; /* Tamanho da spinner */
  animation: spin 1s linear infinite; /* Animação de rotação */
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>